import { ProcessPaymentType } from '../ProcessPaymentType';
import { useGetPaymentTypesEnabledSettingSuspense } from './useGetPaymentTypesEnabledSettingSuspense';
import { processPaymentTypeCardGroupMap } from './utils';

interface GetRecordPaymentOptions {
    accountId: string;
    allowedPaymentTypes: ProcessPaymentType[];
}

export const useGetRecordPaymentOptionsSuspense = ({ accountId, allowedPaymentTypes }: GetRecordPaymentOptions) => {
    const paymentTypesEnabledSetting = useGetPaymentTypesEnabledSettingSuspense({ accountId });

    return [
        ...(allowedPaymentTypes.includes(ProcessPaymentType.CashPayment)
            ? [processPaymentTypeCardGroupMap[ProcessPaymentType.CashPayment]]
            : []),
        ...[
            ProcessPaymentType.ExternalCardPayment,
            ProcessPaymentType.ExternalPayment,
            ProcessPaymentType.RecordCard,
            ProcessPaymentType.ExternalCardPreauth,
        ]
            .filter(
                (paymentType) => allowedPaymentTypes.includes(paymentType) && paymentTypesEnabledSetting[paymentType]
            )
            .map((paymentType) => processPaymentTypeCardGroupMap[paymentType]),
    ];
};
